export default "assets/images/logo-b7d45366.png";